"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getPathname", {
    enumerable: true,
    get: function() {
        return getPathname;
    }
});
function getUrlWithoutHost(url) {
    return new URL(url, "http://n");
}
function getPathname(url) {
    return getUrlWithoutHost(url).pathname;
}

//# sourceMappingURL=url.js.map